import { render, staticRenderFns } from "./BlockThankYou.vue?vue&type=template&id=03612a1e&scoped=true"
import script from "./BlockThankYou.vue?vue&type=script&lang=js"
export * from "./BlockThankYou.vue?vue&type=script&lang=js"
import style0 from "./BlockThankYou.vue?vue&type=style&index=0&id=03612a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03612a1e",
  null
  
)

export default component.exports